import React, { useState } from 'react';
import { SectionHead, ProductFrame, Icon, CheckList } from './Primitives';
import './UnitySourceStory.css';
export default function UnitySourceStory({ assetBase }) {
  const [mode, setMode] = useState('source');
  return (
    <section className="ul-section ul-source" id="create">
      <div className="ul-container">
        <div className="ul-source-heading">
          <SectionHead
            eyebrow="01 / Create with confidence"
            title={
              <>
                Your next programme
                <br />
                is closer than you think.
              </>
            }
          >
            The knowledge is already there. Unity helps you turn it into a structured programme,
            then build the lessons that bring it to life.
          </SectionHead>
          <div className="ul-source-note">
            <Icon name="file" size={28} />
            <p>
              Policies. Technical manuals.
              <br />
              Induction guides. Your ideas.
            </p>
          </div>
        </div>
        <div className="ul-source-grid">
          <div className="ul-source-options">
            <div className="ul-segmented" aria-label="Programme creation route">
              <button
                type="button"
                aria-pressed={mode === 'source'}
                onClick={() => setMode('source')}
              >
                Build from documents
              </button>
              <button
                type="button"
                aria-pressed={mode === 'manual'}
                onClick={() => setMode('manual')}
              >
                Build it yourself
              </button>
            </div>
            {mode === 'source' ? (
              <>
                <h3>
                  Start with what
                  <br />
                  your business knows.
                </h3>
                <p>
                  Upload your source PDFs. Shape the brief. Review the programme structure. Then
                  generate and refine your learning content.
                </p>
                <CheckList
                  items={[
                    'Choose documents-only or allow expansion',
                    'Review the structure before publication',
                    'Generate content in manageable stages',
                  ]}
                />
              </>
            ) : (
              <>
                <h3>
                  Your expertise.
                  <br />
                  Your starting point.
                </h3>
                <p>
                  Build the programme structure yourself, then use Unity’s content tools to create,
                  enrich and review the lessons.
                </p>
                <CheckList
                  items={[
                    'Define modules, units and outcomes',
                    'Keep the curriculum you already trust',
                    'Use AI where it helps your workflow',
                  ]}
                />
              </>
            )}
            <div className="ul-source-governance">
              <Icon name="shield" />
              <span>
                AI helps with preparation.
                <br />
                <strong>Your team approves the training.</strong>
              </span>
            </div>
          </div>
          <div className="ul-source-screen">
            <ProductFrame
              src={`${assetBase}/product/${mode === 'source' ? 'source-builder.png' : 'build-choice.png'}`}
              width={mode === 'source' ? 1916 : 1919}
              height={mode === 'source' ? 899 : 900}
              crop={mode === 'source' ? [428, 99, 1302, 670] : [438, 145, 1302, 485]}
              alt={
                mode === 'source'
                  ? 'Unity source builder with documents-only and expansion-allowed controls'
                  : 'Unity programme creation choices for AI-assisted and manual building'
              }
              caption="Actual Unity interface · selected viewport"
            />
            <div className="ul-source-steps">
              <span>
                <b>01</b> Your sources
              </span>
              <span>
                <b>02</b> Your programme
              </span>
              <span>
                <b>03</b> Your approval
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
